import { render } from "./TabletAndMobileLogo.vue?vue&type=template&id=af384d74&ts=true"
import script from "./TabletAndMobileLogo.vue?vue&type=script&lang=ts"
export * from "./TabletAndMobileLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__